export default __webpack_public_path__ + "static/image6-295c55d926d9fdf800fd65603e21b66d.jpeg";